module.exports = __webpack_public_path__ + "static/media/settings-active-icon.04af141b.svg";